import { MenuItem, useDisclosure, useToast } from "@chakra-ui/react";
import { MdOutlineEdit } from "react-icons/md";
import { useIntl } from "react-intl";

import { getDescription, getId, getName } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";
import { usePublicationEditModal } from "../hooks/use-edit";

import { PublicationDetailEditForm } from "./edit-form";

export function PublicationDetailEdit() {
  const intl = useIntl();
  const disclosure = useDisclosure();
  const toast = useToast();

  const publicationId = usePublicationStore(getId);
  const name = usePublicationStore(getName);
  const description = usePublicationStore(getDescription);

  const onSuccess = () => {
    disclosure.onClose();

    toast({
      title: intl.formatMessage({
        id: "publication.edit_metadata_success",
        defaultMessage: "Publication metadata has been updated successfully for all versions",
      }),
      status: "success",
    });
  };

  const hookReturn = usePublicationEditModal({ onSuccess, publicationId });

  const buttonText = intl.formatMessage({
    id: "publication.edit_metadata",
    defaultMessage: "Edit metadata",
  });

  return (
    <PublicationDetailEditForm
      {...disclosure}
      {...hookReturn}
      buttonText={buttonText}
      initialValues={{
        name,
        description: description + "",
      }}
      buttonProps={{
        justifyContent: "flex-start",
        w: "full",
        as: MenuItem,
        icon: <MdOutlineEdit />,
      }}
    />
  );
}
